/**
 * @mixin
 */
export default {
    props: {
        name: {
            type: String,
            required: true
        },
        id: {
            type: String,
            validator: prop => {
                return (typeof prop === "string") || (prop === null)
            },
            default: null
        },
        value: {
            default: null
        },
        placeholder: {
            type: String,
            default: ""
        },
        min: { // days from today
            type: Number,
            default: null
        },
        max: { // days from today
            type: Number,
            default: null
        },
        dateFilter: {
            type: String,
            default: "YYYY-MM-DD"
        },
        editable: {
            type: Boolean,
            default: true
        }
    }
}
